import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import cart from './modules/cart'
import user from './modules/user'
import errorLog from './modules/errorLog'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    cart,
    errorLog
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js